import { Controller } from '@hotwired/stimulus'

export default class GoogleAdsController extends Controller {
  static values = {
    orderTotal: Number,
    orderId: Number,
    eventId: String,
    currency: { type: String, default: 'MXN' }
  }

  connect () {
    if (!window.gtag) {
      return
    }

    // Event snippet to track different conversion events
    window.gtag('event', 'conversion', this.eventOptions())
  }

  eventOptions () {
    const options = {
      send_to: this.eventIdValue
    }

    if (this.hasOrderTotalValue) {
      options.value = this.orderTotalValue
      options.currency = this.currencyValue
    }

    if (this.hasOrderIdValue) {
      options.transaction_id = this.orderIdValue
    }

    return options
  }
}
